import { DirectDebit } from './DirectDebit';

export class Order {
  constructor({
    orderID = 0,
    orderType = 0,
    orderStatus = 0,
    createdDate = new Date(),
    customerID = 0,
    dealerID = 0,
    directDebit = new DirectDebit(),
    hardwareID = 0,
    iPOrderID = 0,
    internetID = 0,
    landlineID = 0,
    existingCustomer = false,
    signature = '',
    contacts = [],
    orderGUID = '{00000000-0000-0000-0000-000000000000}',
    isUsingExistingDirectDebit = false,
    docuSignEnvelopeID = '',
    relocationID = 0,
    isQuote = false,
    relatedOrder = 0,
    financedHardware = false,
    isReporting = false
  } = {}) {
    this.orderID = orderID;
    this.orderType = orderType;
    this.orderStatus = orderStatus;
    this.createdDate = createdDate;
    this.customerID = customerID;
    this.dealerID = dealerID;
    this.directDebit = directDebit;
    this.hardwareID = hardwareID;
    this.iPOrderID = iPOrderID;
    this.internetID = internetID;
    this.landlineID = landlineID;
    this.signature = signature;
    this.orderGUID = orderGUID;
    this.existingCustomer = existingCustomer;
    this.contacts = contacts;
    this.financedHardware = financedHardware;
    this.isUsingExistingDirectDebit = isUsingExistingDirectDebit;
    (this.docuSignEnvelopeID = docuSignEnvelopeID),
      (this.relocationID = relocationID),
      (this.isQuote = isQuote),
      (this.relatedOrder = relatedOrder);
    this.isReporting = isReporting;
  }
}

export function createOrder(data) {
  return Object.freeze(new Order(data));
}
